import { render, staticRenderFns } from "./ScreenStationUpdate.vue?vue&type=template&id=2cd0240f&"
import script from "./ScreenStationUpdate.vue?vue&type=script&lang=js&"
export * from "./ScreenStationUpdate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports